import { buildTranslate } from 'locales'
import React, { useRef } from 'react'
import Coupon from './Coupon'
import Envelope from './Envelope'
import './heroScene.scss'
import PhoneCheckout from './PhoneCheckout'
import { HERO_END_STATE } from './timeline'
import useHeroClock from './useHeroClock'
import useHeroScale from './useHeroScale'

const t = buildTranslate('promo_codes.overview.hero.animation')

type Props = {
  ariaLabel: string
  isStatic: boolean
  isPaused: boolean
}

const HeroScene = ({ ariaLabel, isStatic, isPaused }: Props) => {
  const frameRef = useRef<HTMLDivElement>(null)
  const stageRef = useRef<HTMLDivElement>(null)
  const scale = useHeroScale(frameRef)
  const promoCode = t('promo_code')

  const clockState = useHeroClock({
    stageRef,
    enabled: !isStatic && !isPaused,
    codeLength: promoCode.length,
  })

  const textState = isStatic ? HERO_END_STATE : clockState

  const modifiers = [
    isStatic ? 'hero-scene--static' : '',
    isPaused ? 'hero-scene--paused' : '',
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <div
      ref={frameRef}
      role="img"
      aria-label={ariaLabel}
      className={`hero-scene ${modifiers}`}
      data-testid="promo-codes-hero-scene"
    >
      <div
        ref={stageRef}
        aria-hidden="true"
        className="hero-scene__stage"
        style={{ transform: `scale(${scale})` }}
      >
        <div className="hero-envelope">
          <Envelope />
          <Coupon />
        </div>
        <PhoneCheckout {...textState} promoCode={promoCode} />
      </div>
    </div>
  )
}

export default HeroScene
